import { useState } from 'react';

const HeaderNavigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="relative z-50">
      <div className="mx-auto px-8">
        <div className="flex justify-between items-center h-[80px]">
          {/* Logo */}
          <a 
            href="https://peatix.com/us/" 
            className="flex items-start shrink-0 flex-nowrap relative"
          >
            <img 
              src="/host/images/peatix-logo.svg"
              alt="Peatix Logo" 
              className="w-[142px] h-[32px] shrink-0 relative" 
            />
          </a>

          {/* Navigation */}
          <div className="flex items-center gap-4">
            {/* Hamburger menu button */}
            <div className="relative z-50">
              <button 
                className={`
                  md:hidden p-2 rounded-lg
                  ${isMenuOpen ? 'bg-white text-gray-600' : 'text-gray-600'}
                `}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                <svg 
                  className="w-6 h-6" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  {isMenuOpen ? (
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M6 18L18 6M6 6l12 12" 
                    />
                  ) : (
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M4 6h16M4 12h16M4 18h16" 
                    />
                  )}
                </svg>
              </button>
            </div>

            {/* Desktop menu */}
            <div className="hidden md:flex gap-4 items-center shrink-0 flex-nowrap relative z-30">
              <div className="flex px-[18px] py-2.5 gap-2 justify-center items-center shrink-0 flex-nowrap rounded-lg hover:bg-[#f9fafb] transition-colors relative overflow-hidden">
                <a
                  href="https://peatix.com/us/visiting-japan"
                  className="no-underline"
                >
                  <span className="h-6 shrink-0 basis-auto text-base font-semibold leading-6 text-gray-700 relative text-left whitespace-nowrap">
                    Visiting Japan
                  </span>
                </a>
              </div>
              <div className="flex px-[18px] py-2.5 gap-2 justify-center items-center shrink-0 flex-nowrap rounded-lg hover:bg-[#f9fafb] transition-colors relative overflow-hidden">
                <a 
                  href="https://peatix.com/us/signin"
                  className="no-underline"
                >
                  <span className="h-6 shrink-0 basis-auto text-base font-semibold leading-6 text-gray-700 relative text-left whitespace-nowrap">
                    Sign in
                  </span>
                </a>
              </div>
              <div className="flex px-[18px] py-2.5 gap-2 justify-center items-center shrink-0 flex-nowrap rounded-lg hover:bg-[#f9fafb] transition-colors relative overflow-hidden border border-transparent">
                <a 
                  href="https://peatix.com/us/signup"
                  className="no-underline"
                >
                  <span className="h-6 shrink-0 basis-auto text-base font-semibold leading-6 text-gray-700 relative text-left whitespace-nowrap">
                    Register
                  </span>
                </a>
              </div>
                <a 
                  href="https://peatix.com/us/event/create" 
                  className="flex px-[18px] py-2.5 gap-2 justify-center items-center shrink-0 flex-nowrap bg-primary-600 hover:bg-primary-700 transition-colors rounded-lg border border-primary-600 relative overflow-hidden shadow-sm pointer border border-transparent"
                >
                  <span className="h-6 shrink-0 basis-auto text-base font-semibold leading-6 text-white relative text-left whitespace-nowrap">
                    Create event
                  </span>
                </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu overlay */}
      <div 
        className={`
          fixed inset-0 bg-white transition-transform duration-300 ease-in-out md:hidden
          ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
          z-[1000]
        `}
      >
        {/* Mobile menu header */}
        <div className="h-[80px] px-4 flex items-center justify-between">
          <a 
            href="https://peatix.com/us/" 
            className="flex items-start shrink-0 flex-nowrap relative"
          >
            <img 
              src="/host/images/peatix-logo.svg"
              alt="Peatix Logo" 
              className="w-[142px] h-[32px] shrink-0 relative" 
            />
          </a>
          <button 
            className="p-2 text-gray-600 rounded-lg"
            onClick={() => setIsMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg 
              className="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        </div>

        {/* Mobile menu content */}
        <div className="py-6">
          <div className="flex flex-col">
            <a
              href="https://peatix.com/us/visiting-japan"
              className="py-3 px-4 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors text-base font-semibold"
            >
              Visiting Japan
            </a>
            <a 
              href="https://peatix.com/us/signin" 
              className="py-3 px-4 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors text-base font-semibold"
            >
              Sign in
            </a>
            <a 
              href="https://peatix.com/us/signup" 
              className="py-3 px-4 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors text-base font-semibold"
            >
              Register
            </a>
              <a 
                href="https://peatix.com/us/event/create" 
                className="py-3 px-4 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors text-base font-semibold"
              >
                Create event
              </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderNavigation; 